module.exports = __webpack_public_path__ + "img/shili1.2bfb81ae.png";